import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ModalController, ViewWillEnter } from '@ionic/angular';
import { RequestHeaderModel } from 'src/app/models/request-header.model';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { RequestService } from 'src/app/services/request.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
})
export class OrdersComponent implements OnInit, ViewWillEnter, OnDestroy {

  orders: RequestHeaderModel[] = [];

  displays: boolean[] = [];

  constructor(
    private mdlctrl: ModalController,
    public dataServ: DataService,
    public reqServ: RequestService,
    private authServ: AuthService,
    private titleService: Title,
  ) { }

  async ngOnInit() {

    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    this.orders = await this.reqServ.getOrders(this.authServ.profile.id);

  }

  ionViewWillEnter(): void {
    this.titleService.setTitle('My Orders');
  }

  ngOnDestroy(): void {
    this.titleService.setTitle('My Profile');
  }

  async close() {
    await this.mdlctrl.dismiss();
  }
}
